import { render, staticRenderFns } from "./Breadcurmb.vue?vue&type=template&id=a46ed2c4&scoped=true"
import script from "./Breadcurmb.vue?vue&type=script&lang=js"
export * from "./Breadcurmb.vue?vue&type=script&lang=js"
import style0 from "./Breadcurmb.vue?vue&type=style&index=0&id=a46ed2c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46ed2c4",
  null
  
)

export default component.exports